<!-- Modal -->
<form class="form-horizontal" [formGroup]="form" novalidate (ngSubmit)="form.valid && confirm()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Información de Referencias Bancarias / Comerciales</h5>
        <div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div class="modal-body">
          <div class="form-group row">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Nombre Encargado de Confirmar</b>
              <span appRequiredAsterisk [formGroup]="form" controlName="name"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
              <input type="text" class="form-control" formControlName="name" [ngClass]="form.controls.name.errors ? 'is-invalid' : 'is-valid'">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Nombre de la Institución</b>
              <span appRequiredAsterisk [formGroup]="form" controlName="institutionName"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
              <input type="text" class="form-control" formControlName="institutionName" [ngClass]="form.controls.institutionName.errors ? 'is-invalid' : 'is-valid'">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Fecha Inicio de Relación</b>
              <span appRequiredAsterisk [formGroup]="form" controlName="relationshipInitialDate"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
              <input bsDatepicker class="form-control" formControlName="relationshipInitialDate" [ngClass]="form.controls.relationshipInitialDate.errors ? 'is-invalid' : 'is-valid'" [bsConfig]="{ isAnimated: true, containerClass:'theme-blue', displayOneMonthRange: true, selectFromOtherMonth:true }">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-8">
              <label class="col-form-label"><b>Teléfono</b>
                <span appRequiredAsterisk [formGroup]="form" controlName="phone"></span>
              </label>
              <input type="text" class="form-control" formControlName="phone" [ngClass]="form.controls.phone.errors ? 'is-invalid' : 'is-valid'" [mask]="'0000-0000'" [showMaskTyped]="true">
            </div>
            <div class="form-group col-md-4">
              <label class="col-form-label"><b>Extensión</b>
                <span appRequiredAsterisk [formGroup]="form" controlName="phoneExtension"></span>
              </label>
              <input type="text" class="form-control" formControlName="phoneExtension">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Tipo de Relación</b>
              <span appRequiredAsterisk [formGroup]="form" controlName="relationshipType"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
              <ng-select formControlName="relationshipType" [items]="relationshipTypes" bindLabel="value" bindValue="key"></ng-select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="close()">Cancelar</button>
            <button type="button" class="btn btn-outline-primary" (click)="draft()"><i class="fa fa-plus"></i>&nbsp;Borradores</button>
            <button type="submit" class="btn btn-outline-success">Confirmar</button>
        </div>
    </div>
    </form>
    